import React, { useEffect } from "react";
import { Table } from "antd";
import { useBeModel } from "../beModel";
import { IMdBeDetail } from "../beService";
import { ColumnsType } from "antd/es/table";



export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,
        accountBankTypeDs,
        setSelectedData,
    } = useBeModel();
    const columns: ColumnsType<IMdBeDetail> = [
        {
            align: "center",
            title: '分支',
            width: 80,
            dataIndex: 'branch',
        },
        {
            align: "center",
            title: '版本',
            width: 80,
            dataIndex: 'ver',
        },
        // {
        //     align: "center",
        //     title: '禁用',
        //     dataIndex: 'enable',
        //     render: v => v === 1 ? "否" : "是"
        // },
        {
            align: "center",
            title: '编码',
            dataIndex: 'code',
        },
        {
            align: "center",
            title: '名称',
            dataIndex: 'name',
        },
        {
            align: "center",
            title: '法人',
            dataIndex: 'corporation',
        },
        {
            align: "center",
            title: '联系电话',
            dataIndex: 'phone',
        },
        {
            align: "center",
            title: '注册地址',
            dataIndex: 'address',
        },
        {
            align: "center",
            title: '开户行',
            dataIndex: 'bank',
            // render:(text)=> text
            render: (text) => accountBankTypeDs.find(item => ((item.value == text)))?.label || text

        },
        {
            align: "center",
            title: '银行账户',
            dataIndex: 'bankAcct',
        },
        {
            align: "center",
            title: '状态',
            dataIndex: 'enable',
            render: (v) => v === 1 ? "可用" : "不可用"
        },
        {
            align: "center",
            title: '备注',
            dataIndex: 'note',
        },

    ];
    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdBeDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                            setSelectedData(record)
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content' }}
        />
    )
}
